export const SET_LOYALTY = 'SET_LOYALTY';
export const LOYALTY_ERROR = 'LOYALTY_ERROR';
